export default __webpack_public_path__ + "static/Year1890b-43ab3c65ae09a6d7277ef53eb79934fc.png";